import React from "react";
import BeneficiaryDropdown from "../BeneficiaryDropdown";
import { useTranslation } from "react-i18next";

function StrategiesMission() {
  const { t } = useTranslation();
  return (
    <section className="strategies-mission align-items-center">
      <div className="strategies-mission flex-nowrap order-2 order-md-1">
        <div>
          <div className="vertical-design"></div>
        </div>
        <div>
          <h4>{t("home:strategies-mission:title", "Roma Strategies and mission")}</h4>
          <h6>{t("home:strategies-mission:sub-title-strategies", "Strategies")}</h6>
          <p>
            {t("home:strategies-mission:sub-summary-strategies", "Leverage cutting-edge technologies like .NET, MERN, and Flutter to deliver scalable and innovative solutions")}
          </p>
          <h6>{t("home:strategies-mission:sub-title-mission", "Mission")}</h6>
          <p>
            {t("home:strategies-mission:sub-summary-mission", "Empower businesses through technology-driven solutions that enhance efficiency, scalability, and growth. Our commitment is to deliver top-notch services that meet client needs and exceed expectations.")}
          </p>
          <BeneficiaryDropdown dropdownTitle={t("home:strategies-mission:country-dropdown","Explore Country Data")} className="btn-theme" />
        </div>
      </div>
      <div className="order-1 order-md-2">
        <img
          src="/images/webp/strategies-mission.webp"
          className="mission-img"
          alt=""
        />
      </div>
    </section>
  );
}

export default StrategiesMission;
